import { REMOVE_MESSAGE, ADD_MESSAGE, TOGGLE_LOADING } from "./types";
import uuid from "react-uuid";
import CheckMarkIcon from "@atlaskit/icon/core/check-mark";
import StatusInformationIcon from "@atlaskit/icon/core/status-information";
import StatusWarningIcon from "@atlaskit/icon/core/status-warning";
import StatusErrorIcon from "@atlaskit/icon/core/status-error";
import { colors } from "@atlaskit/theme";
export const toggleLoading = (status, message) => (dispatch) => {
  dispatch({
    type: TOGGLE_LOADING,
    payload: { status: status, loadingMessage: message },
  });
};

export const addMessage = (subject, message, type) => (dispatch) => {
  const msg = createMessage(message, subject, type);
  dispatch({
    type: ADD_MESSAGE,
    payload: msg,
  });
};

export const removeMessage = (messageId) => (dispatch) => {
  dispatch({
    type: REMOVE_MESSAGE,
    payload: messageId,
  });
};

export const createMessage = (description, title, type) => {
  const uid = uuid();
  let theIcon = "";
  switch (type) {
    case "info":
      theIcon = <StatusInformationIcon label="Info icon" />;
      break;
    case "warn":
      theIcon = <StatusWarningIcon label="Warning" />;
      break;
    case "error":
      theIcon = <StatusErrorIcon label="Error" />;
      break;
    case "success":
      theIcon = <CheckMarkIcon color={colors.G300} label="Success" />;
      break;
    default:
      theIcon = <StatusInformationIcon label="Info icon" />;
      break;
  }

  return {
    created: Date.now(),
    description: description,
    icon: theIcon,
    id: uid,
    key: uid,
    title: title,
    type: type,
  };
};
